export enum watIsUwVraag {
  optionBerekeningEigenBijdrage = "BerekeningVanMijnEigenBijdrage",
  optionDocumentOfFormulierDigitaalOpsturen = "DocumentOfFormulierDigitaalOpsturen",
  optionEigenBijdrageAutomatischBetalen = "EigenBijdrageAutomatischBetalen",
  optionOpenstaandSaldoOpvragen = "OpenstaandSaldoOpvragen",
  optionIetsAnders = "IetsAnders"
}
